var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0250102 9.50182C0.110564 4.35535 4.94816 -0.160926 10.1925 0.00709488C12.7183 -0.097896 15.0729 0.973431 16.9993 2.48588C16.186 3.41008 15.3298 4.29232 14.4093 5.11161C12.0976 3.53614 8.80119 3.09502 6.46798 4.90154C3.17159 7.12812 3.0217 12.4426 6.21115 14.8794C9.31486 17.6311 15.1799 16.2657 16.0362 12.0435C14.0883 12.0226 12.1404 12.0435 10.2139 11.9805C10.2139 10.8462 10.2139 9.71189 10.2139 8.57754C13.4675 8.57754 16.6997 8.55656 19.9533 8.57754C20.1459 11.2453 19.7821 14.1021 18.1124 16.3078C15.5653 19.8158 10.4707 20.8241 6.51076 19.3326C2.50802 17.8412 -0.296082 13.703 0.0250102 9.50182Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.46dbfc76893dbc3eebece60a01d7ece8.svg";
export { ForwardRef as ReactComponent };